import { MouseEventHandler } from 'react';

export const eventStopPropagation: MouseEventHandler = (event) => {
  // stop propagation to not trigger row click handler
  event.stopPropagation();
};
